const AUTH_TRANSITION_KEY = 'uf:auth:transition:pending';
const AUTH_TRANSITION_MAX_AGE_MS = 30_000;

const hasWindow = () => typeof window !== 'undefined';

export const markAuthTransitionPending = () => {
  if (!hasWindow()) return;
  window.sessionStorage.setItem(AUTH_TRANSITION_KEY, String(Date.now()));
};

export const clearAuthTransitionPending = () => {
  if (!hasWindow()) return;
  window.sessionStorage.removeItem(AUTH_TRANSITION_KEY);
};

export const isAuthTransitionPending = () => {
  if (!hasWindow()) return false;
  const raw = window.sessionStorage.getItem(AUTH_TRANSITION_KEY);
  if (!raw) return false;

  const timestamp = Number(raw);
  if (!Number.isFinite(timestamp)) {
    window.sessionStorage.removeItem(AUTH_TRANSITION_KEY);
    return false;
  }

  const isFresh = Date.now() - timestamp <= AUTH_TRANSITION_MAX_AGE_MS;
  if (!isFresh) {
    window.sessionStorage.removeItem(AUTH_TRANSITION_KEY);
  }

  return isFresh;
};

const hasOAuthUrlSignal = () => {
  if (!hasWindow()) return false;
  try {
    const url = new URL(window.location.href);
    const hasOauthParams =
      url.searchParams.has('code') ||
      url.searchParams.has('state') ||
      url.searchParams.has('error') ||
      url.searchParams.has('error_description');
    const isOauthPath =
      url.pathname.startsWith('/auth/processing') ||
      url.pathname.startsWith('/auth/callback') ||
      url.pathname.startsWith('/oauth-callback') ||
      url.pathname.startsWith('/functions/oauth-callback');
    return hasOauthParams || isOauthPath;
  } catch {
    return false;
  }
};

export const hasOAuthHandoffSignal = () => hasOAuthUrlSignal();

interface AuthTransitionLoadingArgs {
  loading: boolean;
  user: unknown;
  isPasswordRecovery?: boolean;
}

export const shouldShowAuthTransitionLoading = ({
  loading,
  user: _user,
  isPasswordRecovery = false
}: AuthTransitionLoadingArgs) =>
  !isPasswordRecovery && loading;

export const shouldKeepAuthTransitionShell = ({
  user,
  isPasswordRecovery = false
}: Omit<AuthTransitionLoadingArgs, 'loading'>) =>
  !user && !isPasswordRecovery && isAuthTransitionPending();
